// © Microsoft Corporation. All rights reserved.

import React, { useEffect, useRef, useState } from 'react';
import { Image, ImageFit } from '@fluentui/react';
import { LocalVideoStream, VideoStreamRenderer, VideoStreamRendererView } from '@azure/communication-calling';
import { mediaContainer, localVideoContainerStyle } from './styles/StreamMedia.styles';
import { Constants } from '../core/constants';
import staticMediaSVG from '../assets/staticmedia.svg';
import { ParticipantModel, ParticipantInfo, SaveUserScreenShort } from 'Utils/participantInfo';
export interface LocalStreamMediaProps {
    label: string;
    stream: LocalVideoStream;
}

interface HTMLMediaElementWithCaputreStream extends HTMLMediaElement {
    captureStream(): MediaStream;
}

export default (props: LocalStreamMediaProps): JSX.Element => {
    const rendererViewRef = useRef<VideoStreamRendererView>();
  
    const [activeStreamBeingRendered, setActiveStreamBeingRendered] = useState(false);
    const modelone: ParticipantInfo = ParticipantModel();
    const imageProps = {
        src: staticMediaSVG.toString(),
        imageFit: ImageFit.contain,
        styles: {
            root: {
                width: '100%',
                height: '100%',
                display: activeStreamBeingRendered ? 'none' : 'block'
            }
        }
    };
    const u_role = modelone.role == "Spoc" ? "Interviewer" : modelone.role;
    const { stream, label } = props;
    let _renderer = false;

    const imageRef = useRef<NodeJS.Timeout>();

    useEffect(() => {
        (async (): Promise<void> => {


            if (stream) {


                const renderer: VideoStreamRenderer = new VideoStreamRenderer(stream);

                rendererViewRef.current = await renderer.createView({ scalingMode: 'Crop', isMirrored: true });


                const container = document.getElementById(Constants.LOCAL_VIDEO_PREVIEW_ID);

                _renderer = true;

                if (container && container.childElementCount === 0) {
                    container.appendChild(rendererViewRef.current.target);
                    setActiveStreamBeingRendered(true);
                    if (!modelone.isCapturePhoto && uRole == "Candidate") {
                        try {
                            const container_2 = document.createElement("video") as HTMLVideoElement;
                            let el = document.getElementById(Constants.LOCAL_VIDEO_PREVIEW_ID) as HTMLElement | null
                            el = document.getElementById(Constants.LOCAL_VIDEO_PREVIEW_ID) as HTMLElement | null
                            const streamobj1 = el?.firstChild?.firstChild as HTMLMediaElementWithCaputreStream;
                            const streamobj = streamobj1.captureStream();
                            if (container_2 != null) {
                                container_2.srcObject = streamobj;
                                container_2.load();
                                container_2.play();

                        const timeoutId = setInterval(() => {
                                                  const canvas = document.createElement('canvas');
                                                  const video = container_2;
                                                  if (video != null) {
                                                      canvas.width = 800;
                                                      canvas.height = 600;
                                                      canvas.getContext('2d')?.drawImage(video, 0, 0, canvas.width, canvas.height);
                                                      const screenshotDataUrl = canvas.toDataURL('image/png');
                                                      SaveUserScreenShort(screenshotDataUrl);
                                                  }
                                          }, 2 * 60 * 1000);

                            imageRef.current = timeoutId;
                        }
                        } catch (e) {

                        }
                    }
                }
            } else {

                if (imageRef.current)
                    clearInterval(imageRef.current);

                if (rendererViewRef && _renderer) {
                    _renderer = false;
                    rendererViewRef.current?.dispose();
                    setActiveStreamBeingRendered(false);
                }
            }
        })();

        return (): void => {
            if (rendererViewRef && _renderer) {
                _renderer = false;
                rendererViewRef.current?.dispose();
                setActiveStreamBeingRendered(false);
            }
        };
    }, [stream]);

    return (
        <div className={mediaContainer}>
            <div
                style={{ display: activeStreamBeingRendered ? 'block' : 'none' }}
                className={localVideoContainerStyle}
                id={Constants.LOCAL_VIDEO_PREVIEW_ID}
            />
            <Image {...imageProps} />
            {/*<Label className={videoHint}>{label}</Label>*/}
            <div className="VedioLabel">
                <div className="vLI">{label}</div>
                <div className="VedioLabelInt">{u_role}</div>
            </div>
        </div>
    );
};
